<template>
    <v-layout>
        <v-flex xs12>
            <v-card v-if="sideMode&&discDialog">
                <v-card-title class="primary headline white--text">
                    Connectors > {{ discItem.name }} > {{ 'discovered points'|translate }}
                </v-card-title>
                <v-card-actions>
                    <span style="width:200px;"><v-text-field class="ml-3 mr-3" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <div style="width: 200px;">
                        <v-switch color="success"
                                  v-model="discOnlyNew"
                                  :label="'Unmapped Only'|translate"
                        ></v-switch>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn @click="discDialog =false" outline class="mr-2">{{ 'Back to Connectors'|translate }}</v-btn>
                    <v-btn @click="exportPoints()" class="primary elevation-4 mr-2">{{ 'Export'|translate }}</v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-progress-linear :indeterminate="true" v-if="discLoading"></v-progress-linear>
                    <v-data-table
                        :headers="compactDiscHeaders"
                        disable-initial-sort
                        :items="discPoints"
                        :search="search2"
                        v-if="!discLoading"
                        :expand="expand"
                        item-key="upstream_id"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                    >
                        <template v-slot:items="props">
                            <tr @click="props.expanded = !props.expanded">
                                <td class="text-xs-left">{{ props.item.upstream_id }}</td>
                                <td class="text-xs-left">{{ props.item.floor }}</td>
                                <td class="text-xs-left">{{ props.item.equip_type }}</td>
                                <td class="text-xs-left">{{ props.item.equip }}</td>
                                <td class="text-xs-left">{{ props.item.upstream_sensor_name }}</td>
                                <td class="text-xs-left">{{ props.item.sensor_name }}</td>
                                <td class="text-xs-left">
                                    <v-tooltip top v-if="$can('update', 'Points')">
                                        <template v-slot:activator="{ on }">
                                            <v-icon
                                                v-on="on"
                                                small
                                                class="mr-2"
                                                @click="addToPoint(props.item)"
                                            >
                                                fa-plus
                                            </v-icon>
                                        </template>
                                        <span>{{ 'Map'|translate }}</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:expand="props">
                            <v-card flat>
                                <v-card-text class="pa-4">
                                    <v-layout>
                                        <v-flex md6>
                                            <p v-if="props.item.path"><strong>path : </strong>{{ props.item.path }}</p>
                                            <p v-if="props.item.sensor_desc"><strong>sensor_desc
                                                : </strong>{{ props.item.sensor_desc }}</p>
                                            <p v-if="props.item.site"><strong>site : </strong>{{ props.item.site }}</p>
                                            <p v-if="props.item.unit"><strong>unit : </strong>{{ props.item.unit }}</p>
                                        </v-flex>
                                        <v-flex md6>
                                            <p v-if="props.item.meta"><strong>meta : </strong>{{ props.item.meta }}</p>
                                            <p v-if="props.item.equip_meta"><strong>equip_meta
                                                : </strong>{{ props.item.equip_meta }}</p>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <v-card v-if="!(sideMode&&discDialog)">
                <v-card-title class="headline primary white--text">
                    {{ 'Connectors'|translate }}
                </v-card-title>
                <v-card-actions v-if="!sideMode">
                    <v-spacer></v-spacer>
                    <v-btn class="accent mr-2" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Connector')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <connector-dialog v-model="dialog" :item="editedItem" v-on:doreload="refresh()"></connector-dialog>

                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="connectors"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                        class="elevation-1"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.connector_id }}</td>
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.type }}</td>
                            <td>
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="!sideMode&&$can('update', 'Connector')"
                                    @click="editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon><v-icon
                                    small
                                    class="mr-2"
                                    v-if="!sideMode&&$can('update', 'Connector')"
                                    @click="duplicateItem(props.item)"
                                >
                                    fa-copy
                                </v-icon>
                                <v-tooltip top v-if="!sideMode&&$can('update', 'Connector')">
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            small
                                            v-on="on"
                                            class="mr-2"
                                            @click="runDiscovery(props.item)"
                                        >
                                            fa-search-plus
                                        </v-icon>
                                    </template>
                                    <span>{{ 'Request discovery'|translate }}</span>
                                </v-tooltip>

                                <v-tooltip top v-if="$can('update', 'Connector')">
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            small
                                            v-on="on"
                                            class="mr-2"
                                            @click="liveMode=false; discItem=props.item; showDiscoveryResult(props.item)"
                                        >
                                            fa-search
                                        </v-icon>
                                    </template>
                                    <span>{{ 'View discovered points'|translate }}</span>
                                </v-tooltip>
                                <v-tooltip top v-if="$can('update', 'Connector')&&allowLive">
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                            v-on="on"
                                            small
                                            class="mr-2"
                                            @click="liveMode=true; discItem=props.item; showDiscoveryResult(props.item)"
                                        >
                                            fa-search-location
                                        </v-icon>
                                    </template>
                                    <span>{{ 'Run live discovery'|translate }}</span>
                                </v-tooltip>


                                <v-icon
                                    small
                                    v-if="!sideMode&&$can('update', 'Connector')"
                                    @click="deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-dialog v-if="!sideMode" v-model="discDialog" persistent fullscreen>
                    <v-card v-if="discDialog">
                        <v-card-title class="primary headline white--text">
                            {{ discItem.name }} > {{ 'discovered points'|translate }}
                        </v-card-title>
                        <v-card-text>
                            <v-progress-linear :indeterminate="true" v-if="discLoading"></v-progress-linear>
                            <v-data-table
                                :headers="discHeaders"
                                disable-initial-sort
                                :items="discPoints"
                                :search="search2"
                                v-if="!discLoading"
                                :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                :items-per-page="25"
                            >
                                <template v-slot:items="props">
                                    <td class="text-xs-left">{{ props.item.upstream_id }}</td>
                                    <td class="text-xs-left">{{ props.item.path }}</td>
                                    <td class="text-xs-left">{{ props.item.floor }}</td>
                                    <td class="text-xs-left">{{ props.item.equip_type }}</td>
                                    <td class="text-xs-left">{{ props.item.equip }}</td>
                                    <td class="text-xs-left">{{ props.item.upstream_sensor_name }}</td>
                                    <td class="text-xs-left">{{ props.item.site }}</td>
                                    <td class="text-xs-left">{{ props.item.sensor_name }}</td>
                                    <td class="text-xs-left">{{ props.item.sensor_desc }}</td>
                                    <td class="text-xs-left">{{ props.item.unit }}</td>
                                    <td class="text-xs-left">{{ props.item.meta }}</td>
                                    <td class="text-xs-left">{{ props.item.equip_meta }}</td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                        <v-card-actions>
                             <span style="width:300px;"><v-text-field class="ml-2" clearable v-model="search" type="text"
                                                                      :label="'Keyword filter'|translate"></v-text-field></span>
                            <div style="width: 200px;">
                                <v-switch color="success"
                                          v-model="discOnlyNew"
                                          :label="'Unmapped Only'|translate"
                                ></v-switch>
                            </div>
                            <v-spacer></v-spacer>

                            <v-btn @click="exportPoints()" class="primary mr-2 elevation-4">{{ 'Export'|translate }}</v-btn>
                            <v-btn href="/builder" class="primary mr-2 elevation-4" v-if="$can('update', 'Points')">{{ 'Map in Builder'|translate }}</v-btn>
                            <v-btn outline @click="discDialog =false">{{ 'Close'|translate }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getConnector, deleteConnector, callAPI, getPoint, putConnector} from '../helper'
import ConnectorDialog from "../components/ConnectorDialog";
import {exportCSV} from '../tocsv'

export default {
    name: 'Connectors',
    props: {
        sideMode: {type: Boolean, default: false},
        equipmentName: {type: String, default: null},
        mappedext: {type: Array, default: null},
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    components: {ConnectorDialog},
    computed: {
        discPoints() {
            if (this.discOnlyNew && this.rawDiscPoints.length > 0) {
                if (this.sideMode && this.mappedext) {
                    let filtered=this.mappedext.filter(x=>x.haystack_id&&x.connector_id===this.discItem.connector_id).map(x=>x.haystack_id.toString())
                    return this.rawDiscPoints.filter(x => filtered.indexOf(x.upstream_id.toString()) < 0)
                } else {
                    let filtered=this.mappedIds.filter(x=>x.haystack_id&&x.connector_id===this.discItem.connector_id).map(x=>x.haystack_id.toString())
                    return this.rawDiscPoints.filter(x => filtered.indexOf(x.upstream_id.toString()) < 0)
                }
            }
            return this.rawDiscPoints
        },
        allowLive() {
            if (this.$store.state.userStore.user) {
                if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"&&this.$store.state.userStore.user.content.role==="admin"){
                    return true
                } else if (process.env.VUE_APP_SUPERUSER&&process.env.VUE_APP_SUPERUSER!==""){
                    return this.$store.state.userStore.user.content.user_name.toLowerCase().includes(process.env.VUE_APP_SUPERUSER)
                } else {
                    return this.$store.state.userStore.user.content.user_name === "jecdavid" || this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")
                }
            }
            return false;
        },

    },
    data() {
        return {
            dialog: false,
            discDialog: false,
            liveMode: false,
            expand: false,
            search: '',
            search2: '',
            timeout: null,
            newPoint: {},
            headers: [
                {text: this.$options.filters.translate('ID'), value: 'connector_id'},
                {text: this.$options.filters.translate('Name'), value: 'name'},
                {text: this.$options.filters.translate('Type'), value: 'type'},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            rawDiscPoints: [],
            mappedIds: [],
            discOnlyNew: true,
            discHeaders: [
                {
                    "text": "upstream_id",
                    "value": "upstream_id"
                },
                {
                    "text": "path",
                    "value": "path"
                },
                {
                    "text": "floor",
                    "value": "floor"
                },
                {
                    "text": "equip_type",
                    "value": "equip_type"
                },
                {
                    "text": "equip",
                    "value": "equip"
                },
                {
                    "text": "upstream_sensor_name",
                    "value": "upstream_sensor_name"
                },
                {
                    "text": "site",
                    "value": "site"
                },
                {
                    "text": "sensor_name",
                    "value": "sensor_name"
                },
                {
                    "text": "sensor_desc",
                    "value": "sensor_desc"
                },
                {
                    "text": "unit",
                    "value": "unit"
                },
                {
                    "text": "meta",
                    "value": "meta"
                },
                {
                    "text": "equip_meta",
                    "value": "equip_meta"
                }
            ],
            compactDiscHeaders: [
                {
                    "text": "upstream_id",
                    "value": "upstream_id"
                },
                {
                    "text": "floor",
                    "value": "floor"
                },
                {
                    "text": "equip_type",
                    "value": "equip_type"
                },
                {
                    "text": "equip",
                    "value": "equip"
                },
                {
                    "text": "upstream_sensor_name",
                    "value": "upstream_sensor_name"
                },
                {
                    "text": "sensor_name",
                    "value": "sensor_name"
                },
                {
                    "text": "Actions",
                    "sortable": false
                }
            ],
            connectors: [],
            discLoading: false,
            discItem: {},
            editedItem: {},
        }
    },

    mounted() {
        this.initialize()
    },
    methods: {
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        addToPoint(item) {
            let newPoint = JSON.parse(JSON.stringify({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                sensor_name: item.sensor_name ? item.sensor_name : item.point,
                sensor_name_abbr: item.sensor_name ? item.upstream_sensor_name : '',
                unit: item.unit,
                haystack_id: item.upstream_id,
                connector_id: this.discItem.connector_id,
                faulty: false,
                weight: 1,
            }))
            if (this.equipmentName) {
                newPoint.equipment_name = this.equipmentName
            }
            this.$emit('addpoint', newPoint)

        },
        async initialize() {
            await this.refreshPoints()
            await this.refresh()
        },
        async refreshPoints() {
            if (!this.sideMode) {
                let df = await getPoint({
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                })
                this.mappedIds = df['result'].map(x=>{return {haystack_id:x.haystack_id,connector_id:x.connector_id}})

            }
        },
        async runDiscovery(item) {
            await callAPI("request-discovery/", {
                connector_id: item.connector_id,
            })
            await this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Discovery requested')})
            await this.refresh()
        },
        async showDiscoveryResult(item) {
            this.discLoading = true
            this.rawDiscPoints = []
            this.discDialog = true
            let disc = await callAPI("discovery/", {
                connector_id: item.connector_id,
                live: this.liveMode
            })
            if (disc && disc.data) {
                let results=disc.data.result
                for (let item of results){
                    if (item.id&&!item.upstream_id){
                        item.upstream_id=item.id
                    }
                    if (item.point&&!item.upstream_sensor_name){
                        item.upstream_sensor_name=item.point
                    }
                    if (item.carnot_name &&!item.sensor_name){
                        item.sensor_name=item.carnot_name
                    }
                }
                this.rawDiscPoints = results
            }
            this.discLoading = false
        },
        exportPoints() {
            let cleanedItems = JSON.parse(JSON.stringify(this.discPoints))
            exportCSV(cleanedItems.map(item => this.formatItem(item)))
        },
        formatItem(item) {
            return {
                upstream_id: item.upstream_id? item.upstream_id : "",
                site: item.site ? item.site : "",
                equip: item.equip ? item.equip : "",
                equip_type: item.equip_type ? item.equip_type : "",
                meta: item.meta ? JSON.stringify(item.meta) : "{}",
                upstream_sensor_name: item.upstream_sensor_name ? item.upstream_sensor_name : "",
                sensor_name: item.sensor_name ? item.sensor_name : "",
                unit: item.unit ? item.unit : "",
                floor: item.floor ? item.floor : "",
                equip_meta: item.equip_meta ? JSON.stringify(item.equip_meta) : "{}",
                sensor_desc: item.sensor_desc ? item.sensor_desc : "",
                connector_id: this.discItem.connector_id,
                calculations_statement: item.calculations_statement ? item.calculations_statement : "",
                all_meta: item.all_meta ? JSON.stringify(item.all_meta) : "{}",
                cur_val: item.cur_val,
            }
        },
        editItem(item) {
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        async duplicateItem(item){
            let newItem=JSON.parse(JSON.stringify(item))
            delete(newItem.connector_id)
            newItem.name=newItem.name+ " copy"
            newItem.facility_name=this.$store.state.pointsListStore.pointsList.facility_name
            await putConnector(newItem)
            await this.refresh()
        },

        async deleteItem(item) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this connector?'))) {
                await deleteConnector({
                    'connector_id': item.connector_id
                })
                this.refresh()
            }
        },
        async refresh() {
            let df = await getConnector({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.connectors = df['result']
        }
    }
}
</script>

<style scoped>

</style>
